export default __webpack_public_path__ + "static/media/banner.42ab310e.webp";